import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#F1F4FA"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path
      fill="#C7D0D9"
      fillRule="evenodd"
      d="M39.203 99.799a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-6 4a6 6 0 1 1 12 0 6 6 0 0 1-12 0"
      clipRule="evenodd"
    />
    <path
      fill="#ACB8C3"
      d="M108.5 91a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5M27.465 32.447a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7"
    />
    <path
      fill="#C7D0D9"
      fillRule="evenodd"
      d="M50.555 3.44a1.5 1.5 0 0 1 0 2.12l-9.994 9.995a1.5 1.5 0 0 1-2.122-2.122l9.994-9.994a1.5 1.5 0 0 1 2.122 0"
      clipRule="evenodd"
    />
    <path
      fill="#C7D0D9"
      fillRule="evenodd"
      d="M38.44 3.44a1.5 1.5 0 0 1 2.12 0l9.995 9.993a1.5 1.5 0 0 1-2.122 2.122L38.44 5.56a1.5 1.5 0 0 1 0-2.122M89.567 87a1.5 1.5 0 0 1 1.5 1.5v14.133a1.5 1.5 0 0 1-3 0V88.5a1.5 1.5 0 0 1 1.5-1.5"
      clipRule="evenodd"
    />
    <path
      fill="#C7D0D9"
      fillRule="evenodd"
      d="M81 95.567a1.5 1.5 0 0 1 1.5-1.5h14.133a1.5 1.5 0 0 1 0 3H82.5a1.5 1.5 0 0 1-1.5-1.5"
      clipRule="evenodd"
    />
    <path
      fill="#ACB8C3"
      d="M87.747 7.975a27.23 27.23 0 0 0-23.159 41.62L58.644 62.08c-.689 1.448.822 2.959 2.269 2.269l12.482-5.946c11.587 7.207 27.049 4.865 35.935-6.396a26.98 26.98 0 0 0 5.599-19.666C113.307 18.085 101.394 7.95 87.747 7.975"
    />
    <path
      fill="#7B8493"
      fillRule="evenodd"
      d="M75.063 28.316a2.25 2.25 0 0 1 2.25-2.25h21.4a2.25 2.25 0 0 1 0 4.5h-21.4a2.25 2.25 0 0 1-2.25-2.25M75.063 39.852a2.25 2.25 0 0 1 2.25-2.25h15.582a2.25 2.25 0 1 1 0 4.5H77.313a2.25 2.25 0 0 1-2.25-2.25"
      clipRule="evenodd"
    />
    <path
      fill="#C7D0D9"
      d="M42.02 66.142c7.34 0 13.29-5.951 13.29-13.291S49.36 39.56 42.02 39.56s-13.291 5.95-13.291 13.29c0 7.341 5.95 13.292 13.29 13.292M61.359 80.395c.824-.004 1.324-.881.944-1.612-3.738-7.192-11.45-12.641-20.02-12.641-8.96 0-16.681 5.309-20.19 12.953-.322.704.233 1.504 1.008 1.5z"
    />
  </svg>
);
const SvgEnrichedIconConsultingGreyscale = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconConsultingGreyscale);
export default Memo;
